import { ISSUE_ATTRIBUTE_NAMES } from '../../constants/issue-attribute-names';
import CommonText from './components/CommonText';

const LocationDetails = () => (
  <CommonText fieldName={ISSUE_ATTRIBUTE_NAMES.LOCATION_DESCRIPTION} label="new.locationDetails" />
);

export default LocationDetails;
